import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

// PDF-/Druckdaten-Service: Fehler hier dürfen die App-Navigation nicht auf die Fehlerseite umleiten
const CarboneApi = createApi(config.CARBONE_API_URL, { redirectOnError: false });

export default CarboneApi;
